import React, {Component} from 'react';
import {Card, CardBody, Col, Table, Button} from 'reactstrap';
import {Link} from 'react-router-dom';
import {connect} from 'react-redux';
import ReactTooltip from 'react-tooltip'
import {initCurrentBlog} from '../../../redux/actions/blogsActions';
import {fetchDrafts} from '../../../redux/actions/draftsActions';
import {fetchPosts} from '../../../redux/actions/postsActions';
import {withTranslation} from "react-i18next";

class YourBlogs extends Component {

    render() {

        const { t } = this.props;
        const {blogs, blog: currentBlog} = this.props.blogs;

        return (
            <Col md={12} lg={6} xl={4}>
                <ReactTooltip place="right" type="info" effect="solid"/>
                <Card>
                    <CardBody>
                        <div className="card__title">
                            <h5 className="bold-text">{t('overview.your_blogs.title')}</h5>
                            <h5 className="subhead">{t('overview.your_blogs.you_have')} {blogs.length} {t('overview.your_blogs.blogs')}</h5>
                        </div>

                        {!blogs.length &&
                        <Link to="/create"><Button color="success" size="sm">{t('menu.create_blog')}</Button></Link>}

                        {blogs && <Table hover responsive className="table--bordered cart__table">
                            <tbody>
                            {blogs.map(blog => {
                                return (
                                    <tr
                                        key={blog._id}
                                        data-tip={t('overview.your_blogs.tooltips.click_to_set_active')}
                                        data-delay-show='500'
                                        onClick={() => {
                                            this.props.onSelectBlog(blog)
                                        }}
                                    >
                                        <td>
                                            <span>{blog.title}</span>
                                        </td>
                                        <td style={{width: "30%"}}>
                                            {currentBlog._id === blog._id &&
                                            <span className="badge badge-success">{t('overview.your_blogs.active')}</span>}
                                        </td>
                                    </tr>
                                )
                            })}
                            </tbody>
                        </Table>
                        }
                    </CardBody>
                </Card>
            </Col>
        )
    }

}

const mapStateToProps = (state) => {
    return {
        blogs: state.blogs
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onSelectBlog: (blog) => {
            dispatch(initCurrentBlog(blog._id));
            dispatch(fetchDrafts(blog._id));
            dispatch(fetchPosts(blog._id));
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation('dashboard')(YourBlogs));
